import _get from "lodash/get";
import _truncate from "lodash/truncate";
import { AnyAction } from "redux";
import { ThunkAction } from "redux-thunk";
import {
    DELIVERY_NOTE_DEFAULT_MAX_LENGTH,
    API_URL_UPDATE_DELIVERY_ADDRESS,
    API_URL_FIND_DELIVERY_ADDRESS,
} from "../../../../../constants";
import { RootState, DeliveryAddressSuggestion } from "../../../../../models";
import * as Ajax from "../../../app/Ajax";
import * as AT from "../actionTypes";

export const setDeliveryNote = (note: string, maxLength = DELIVERY_NOTE_DEFAULT_MAX_LENGTH) => ({
    type: AT.CHECKOUT_SET_DELIVERY_NOTE,
    note: _truncate(note, { length: maxLength, omission: "" }),
});

export const setDeliveryAddress = (
    selectedAddress: DeliveryAddressSuggestion,
): ThunkAction<void, RootState, unknown, AnyAction> => {
    return (dispatch) => {
        return dispatch({
            type: AT.CHECKOUT_UPDATE_DELIVERY_ADDRESS,
            payload: Ajax.post(
                {
                    url: API_URL_UPDATE_DELIVERY_ADDRESS,
                    data: { selectedAddress },
                },
                dispatch,
            ),
        });
    };
};

export const setDeliveryZipCode = (zipCode: string) => ({
    type: AT.CHECKOUT_SET_DELIVERY_ZIPCODE,
    zipCode,
});

export const findDeliveryAddress =
    (address: string): ThunkAction<void, RootState, unknown, AnyAction> =>
    async (dispatch) =>
        dispatch({
            type: AT.CHECKOUT_FIND_DELIVERY_ADDRESS,
            payload: Ajax.get({
                url: API_URL_FIND_DELIVERY_ADDRESS(address),
            }).then((data) => _get(data, "suggestedAddresses", [])),
        });
